import { Box, styled } from '@mui/material';

export const WrapperStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
}));

export const TabButtonsContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hide',
})(({ hide }) => ({
  display: hide ? 'none' : 'flex',
  flexDirection: 'row',
}));
